'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-scroll-into-view/lib/index.js
// module id = 101
// module chunks = 0 1